import { arrayOf, string, shape, bool } from 'prop-types';
import React from 'react';
import Figure from 'components/Figure';
import AmpImg from 'components/AmpImg';

export function RecipeInstructions(props) {
  const { groups, isAmp } = props;

  if (!groups || !groups.length) {
    return null;
  }

  return (
    <div>
      {groups.map(group => (
        <div className="Recipe__instructionsGroup" key={group.id}>
          {group.name && group.name.toLowerCase().trim() !== 'instructions' && (
            <h4>{group.name}</h4>
          )}
          <ol className="Recipe__instructions">
            {group.items.map(instruction => (
              <li className="Recipe__instructionStep" key={instruction.id}>
                {/* CLEANUP: update to pass all image metadata when we have it */}
                {instruction.imageUrl &&
                  (isAmp ? (
                    <AmpImg
                      url={instruction.imageUrl}
                      alt="Recipe Instruction Image"
                    />
                  ) : (
                    <Figure
                      url={instruction.imageUrl}
                      alt="Recipe Instruction Image"
                    />
                  ))}

                <div
                  className="Recipe__instructionStepContent"
                  dangerouslySetInnerHTML={{ __html: instruction.html }}
                />
              </li>
            ))}
          </ol>
        </div>
      ))}
    </div>
  );
}

RecipeInstructions.propTypes = {
  groups: arrayOf(
    shape({
      id: string,
      name: string,
      items: arrayOf(
        shape({
          id: string,
          html: string,
          imageUrl: string
        })
      )
    })
  ),
  isAmp: bool
};

RecipeInstructions.defaultProps = {
  groups: undefined,
  isAmp: false
};

export default RecipeInstructions;
